
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters } from 'vuex';
import StoreModules from '../../store/store-modules';

@Component({
  name: 'SummaryPartial',
  props: {
    userData: {
      type: Object,
      default: () => {}
    },
    selectedActivity: {
      type: Object,
      default: () => {}
    },
    selectedBranch: {
      type: Object,
      default: () => {}
    },
    selectedEmployee: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    // @TODO: looks like most of getter are imported but not used.
    ...mapGetters(StoreModules.CUSTOMER, [
      'companyInformation',
      'companyId',
      'slug',
      'holidays',
      'activities',
      'branches'
    ])
  }
})
export default class SummaryPartial extends Vue {};
